<!--
 * @Function: 创建试卷和编辑试卷
-->

<template>
  <div class="course-create-wrap">
    <a-form :form="form">
      <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="info-title">编辑考试科目</div>
        <div class="info-content" style="padding-top:25px;">
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="考试科目名"
              >
                <a-input
                  placeholder="请输入考试科目名"
                  v-decorator="[
                    'subjectName',
                    {rules: [{ required: true, message: '请输入考试科目名' }]},
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <!-- <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="所属科目"
              >
                <j-dict-select-tag
                  v-decorator="[
                    'subject',
                    {rules: [{ required: true, message: '请选择所属科目' }]},
                  ]"
                  placeholder="请选择所属科目"
                  dictCode="subject"
                  :triggerChange="true"/>
              </a-form-item>
            </a-col>
          </a-row> -->
          <!-- <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="试卷类型"
              >
                <j-dict-select-tag
                  v-decorator="[
                    'paperType',
                    {rules: [{ required: true, message: '请选择试卷类型' }]},
                  ]"
                  placeholder="请选择试卷类型"
                  dictCode="paper_type"
                  :triggerChange="true"/>
              </a-form-item>
            </a-col>
          </a-row> -->
          <!-- <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="试卷难度"
              >
                <span>
                  <a-rate v-model="difficulty" :tooltips="difficultyName" />
                  <span class="ant-rate-text">{{ difficultyName[difficulty - 1] }}</span>
                </span>
              </a-form-item>
            </a-col>
          </a-row> -->
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="考试时间"
              >
               <a-range-picker show-time   format="YYYY-MM-DD HH:mm" style="width:100%" v-model="lastStudyTimeSt"  @change="dateChange"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="考试说明"
              >
              <j-editor
                  v-decorator="[
                    'comment',
                    {rules: [{ required: true, message: '请输入考试说明' }]},
                  ]"
                  triggerChange></j-editor>
                <!-- <a-textarea v-decorator="['comment']" rows="4" placeholder="请输入正文" /> -->
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-card>
      <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);margin-top:20px;">
        <div class="info-title">组卷</div>
        <div class="info-content" style="padding-top:25px;padding-bottom:30px;">
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 22 }"
                label=""
              >
                <div class="j-teacher-add" style="margin-top:4px;margin-bottom:10px;">
                  <a-button
                    style="color:rgb(208, 219, 228);text-align:center;text-shadow:none;width:100%;line-height:34px;height:34px;font-size:14px;background-color:#F4F5F7;border-color:#D0DBE4"
                    type="primary"
                    icon="plus"
                    @click="selectTopic()"
                  > 手动选题
                  </a-button>
                </div>
                <div class="" >
                  <a-row >
                    <a-col :span="24">

                      <a-form-item
                        style="margin-bottom:12px;"
                        :wrapper-col="{ span: 24 }"
                        label="">
                        <a-table
                          ref="table"
                          size="middle"
                          rowKey="id"
                          :columns="columns"
                          :dataSource="paperItemList"
                          @change="pageChange"
                          >
                          <span slot="action" slot-scope="text, record,index" style="width:200px">
                            <a @click="up(index)">上移</a>
                            <a-divider type="vertical" />
                            <a @click="down(index)">下移</a>
                            <a-divider type="vertical" />
                            <a-popconfirm title="确定删除吗?" @confirm="() => delTopic(index)">
                              <a>删除</a>
                            </a-popconfirm>
                          </span>
                          <span slot="stemSlots" slot-scope="text">
                            <!-- <div v-if="text.length > 100"> -->
                              <a-tooltip>
                                <template slot="title">
                                  <p v-html="text" style="height:150px;overflow:auto;"></p>
                                </template>
                                <p v-html="text.replace(/&nbsp;/g,'').substring(0,100)+'...'"></p>
                              </a-tooltip>
                            <!-- </div>
                            <div v-else>
                              <p v-html="text"></p>
                            </div> -->
                          </span>
                        </a-table>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-card>
      <a-card
        :bordered="false"
        style="text-align:center;padding:14px 0px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);margin-top:20px;"
      >
        <div class="a-row">
          <a-button
            style="text-align:center;width:232px;line-height:40px;height:40px;font-size:14px;"
            type="primary"
            @click="examCreateOk()"
          >保存</a-button>
        </div>
      </a-card>
    </a-form>
    <select-topic-modal ref="selectTopicModal" @ok="okSelect"></select-topic-modal>
  </div>
</template>

<script>

  import Vue from 'vue'
  import { ACCESS_TOKEN, TENANT_ID } from '@/store/mutation-types'
  import { getExamItemById,examEdit, examAdd ,addExamItemDetail,editExamItem,queryPaperItemByMainId} from '@/api/api'
  import SelectTopicModal from './modules/SelectTopicModal'
  import pick from 'lodash.pick'
  import _ from 'lodash'
   import moment from 'moment'
  export default {
    name: 'CreateTestItem',
    components: { SelectTopicModal },
    mixins: [],
    data() {
      return {
        // value: '',
        // type: '0',
        // difficulty: 0,
        // difficultyName: [],
        videoFullloading: false,
        isFrom: '',
        form: this.$form.createForm(this),
        loading: false,
        // url: {
        //   fileUpload: window._CONFIG['domianURL'] + '/sys/common/upload'
        // },
        ipagination: false,
        examId:"",
        testItemId:"",
        startTime:"",
        endTime:"",
        lastStudyTimeSt:[],
        dataSource: [],
        columns: [
          {
            title: '题序',
            align: 'center',
            dataIndex: 'sort',
            customRender: (text, row, index) => {
              return (<span >{index + 1}</span>)
            },
            width: 50
          },
          {
            title: '题干',
            align: 'center',
            dataIndex: 'stem',
            width: 260,
            scopedSlots: { customRender: 'stemSlots' }
            // customRender: (text, row) => {
            //   if(text.length>100){
            //     return text.substring(0,100)+"...";
            //   }
            //   return text;
            // }
          },
          {
            title: '所属科目',
            align: 'center',
            dataIndex: 'subject_dictText',
            width: 100
          },
          {
            title: '题库目录',
            align: 'center',
            dataIndex: 'catalogId_dictText',
            width: 100
          },
          {
            title: '题型',
            align: 'center',
            dataIndex: 'type_dictText',
            width: 100
          },
          {
            title: '分值',
            align: 'center',
            dataIndex: 'score',
            width: 50
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            scopedSlots: { customRender: 'action' },
            width: 200
          }
        ],
        paperItemList: [],
        selectExerciseIds: [],
        currentPageNo:1
      }
    },

    methods: {
      pageChange (pagination) {
        this.currentPageNo = pagination.current
        console.log(pagination)
      },
      // 选择题目
      selectTopic () {
        this.$refs.selectTopicModal.open(this.selectExerciseIds)
      },
      // 删除题目
      delTopic(index) {
        this.paperItemList.splice(index,1);
        this.selectExerciseIds.splice(index,1);
      },
      dateChange:function(data,data1){
        // console.log(data,data1)
        this.startTime = data1[0];
        this.endTime = data1[1];
      },
      // 上移
      up(indexParam) {
        let index = indexParam + (this.currentPageNo-1)*10;
        if (index !== 0) {
          let temp = this.paperItemList[index - 1]
          Vue.set(this.paperItemList, index - 1, this.paperItemList[index])
          Vue.set(this.paperItemList, index, temp)
          // this.paperItemList[index-1]=this.paperItemList[index];
          // this.paperItemList[index]=temp;
        }
      },
      // 下移
      down(indexParam) {
        let index = indexParam + (this.currentPageNo-1)*10;
        if (index != this.paperItemList.length - 1) {
          let temp = this.paperItemList[index + 1]
          Vue.set(this.paperItemList, index + 1, this.paperItemList[index])
          Vue.set(this.paperItemList, index, temp)
          // this.paperItemList[index+1]=this.paperItemList[index];
          // this.paperItemList[index]=temp;
        }
      },
      okSelect(selectExercise) {
        let that = this
        selectExercise.forEach(element => {
          if (that.selectExerciseIds.indexOf(element.id) < 0) {
            // element.sort = that.paperItemList.length;
            element.exerciseId = element.id
            that.selectExerciseIds.push(element.id)
            that.paperItemList.push(element)
          }
        })
      },
      examCreateOk() {
        this.form.validateFields((err, values) => {
          if (!err) {
            let id = this.testItemId;
            let examId = this.examId;
            let valuesParam = {}
            valuesParam = { ...values }
            valuesParam.paperItemList = this.paperItemList
            valuesParam.startTime = this.startTime;
            valuesParam.endTime = this.endTime;

            let opFun = ''
            if (_.isEmpty(this.id)) {
              valuesParam = { ...valuesParam, examId }
              opFun = addExamItemDetail(valuesParam)
            } else {
              valuesParam = { ...valuesParam, id }
              opFun = editExamItem(valuesParam)
            }

            opFun.then((res) => {
              if (res.success) {
                this.$message.success(res.message, () => {
                  this.$router.push({ path: '/exerciseManage/testDetailEdite?examId='+examId })
                })
              } else {
                this.$message.warning(res.message)
              }
            }).finally(() => {
            })
          }
        })
      }
    },
    created () {
      this.examId = this.$route.query.examId;
      this.testItemId = this.$route.query.testItemId;

      this.id = this.$route.query.testItemId

      if (!_.isEmpty(this.id)) {
        getExamItemById({ id: this.id }).then((res) => {
          if (res.success) {
            let resultData = res.result
            this.lastStudyTimeSt = [moment(resultData.startTime),moment(resultData.endTime)];
            this.startTime = resultData.startTime;
            this.endTime = resultData.endTime;

            this.$nextTick(() => {
              this.form.setFieldsValue(pick(resultData,'subjectName','comment'))
            })
            if(res.result.paperId){
                queryPaperItemByMainId({ id: res.result.paperId }).then((res3) => {
                if (res3.success) {

                  this.paperItemList = res3.result;
                  this.selectExerciseIds = this.paperItemList.map(ItemVue=>ItemVue.exerciseId);
                } else {
                  this.$message.warning(res3.message)
                }
              }).finally(() => {
              })

            }
            
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {
        });
        
      }
    },
    computed: {
      uploadAction: function () {
        return this.url.fileUpload
      }
    }
  }
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >
.course-create-wrap {
  .info-title {
    border-bottom: 1px solid #e7ecef;
    line-height: 50px;
    height: 50px;
    padding-left: 25px;
  }

  .info-content {
    .img-tip {
      color: #999999;
      font-size: 12px;
    }
  }
  .item-options{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    &:last-child{
      margin-bottom: 0px;
    }
    .item-name{
      padding-right: 10px;
    }
    .item-form{
      flex: 1;
    }
    .right-item{
      padding: 0px 6px;
      margin-left: 10px;
    }
    .item-remove{
      padding: 0px 6px;
      margin-right: 10px;
      cursor: pointer;
    }
  }
}
</style>
